module.exports = __webpack_public_path__ + "static/media/download-area-bg.da68b086.png";